import ContactContent from 'modules/contact/ContactContent'
import React from 'react'

export default function Contact() {
  return (
    <ContactContent />
  )
}
